import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_LABORATORYCONTRACT_LOAD_BY_LABORATORY_ID,
    ACTION_LABORATORYCONTRACT_LOAD_BY_ID,

    ACTION_LABORATORYCONTRACT_SAVE,

    ACTION_LABORATORYCONTRACT_CREATE,

    ACTION_LABORATORYCONTRACT_VALIDATE,

    ILaboratoryContractLoadByLaboratoryIdAction,
    ILaboratoryContractLoadByIdAction,
    ILaboratoryContractLoadFailureAction,
    ILaboratoryContractLoadSuccessAction,

    ILaboratoryContractSaveAction,
    ILaboratoryContractSaveSuccessAction,
    ILaboratoryContractSaveFailureAction,

    ILaboratoryContractCreateAction,
    ILaboratoryContractCreateSuccessAction,
    ILaboratoryContractCreateFailureAction,

    ILaboratoryContractValidateAction,
    ILaboratoryContractValidateSuccessAction,
    ILaboratoryContractValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/laboratoryContract";
import { laboratoryContractApi } from "../services/laboratoryContract";

export const
    getLaboratoryContractByLaboratoryIdEpic = (action$): Observable<ILaboratoryContractLoadSuccessAction | ILaboratoryContractLoadFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYCONTRACT_LOAD_BY_LABORATORY_ID)
            .mergeMap((action: ILaboratoryContractLoadByLaboratoryIdAction) => {
                return laboratoryContractApi
                    .getLaboratoryContractByLaboratoryId(action.laboratoryId)
                    .map(response =>
                        LoadSuccess(response.laboratoryContract, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getLaboratoryContractByIdEpic = (action$): Observable<ILaboratoryContractLoadSuccessAction | ILaboratoryContractLoadFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYCONTRACT_LOAD_BY_ID)
            .mergeMap((action: ILaboratoryContractLoadByIdAction) => {
                return laboratoryContractApi
                    .getLaboratoryContractById(action.id)
                    .map(response =>
                        LoadSuccess(response.laboratoryContract, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setLaboratoryContractEpic = (action$): Observable<ILaboratoryContractSaveSuccessAction | ILaboratoryContractSaveFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYCONTRACT_SAVE)
            .mergeMap((action: ILaboratoryContractSaveAction) => {
                return laboratoryContractApi
                    .setLaboratoryContract(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.laboratoryContract, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createLaboratoryContractEpic = (action$): Observable<ILaboratoryContractCreateSuccessAction | ILaboratoryContractCreateFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYCONTRACT_CREATE)
            .mergeMap((action: ILaboratoryContractCreateAction) => {
                return laboratoryContractApi
                    .createLaboratoryContract(action.laboratoryId)
                    .map(response =>
                        CreateSuccess(
                            response.laboratoryContract,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateLaboratoryContractEpic = (action$): Observable<ILaboratoryContractValidateSuccessAction | ILaboratoryContractValidateFailureAction> => {
        return action$
            .ofType(ACTION_LABORATORYCONTRACT_VALIDATE)
            .mergeMap((action: ILaboratoryContractValidateAction) => {
                return laboratoryContractApi
                    .validateLaboratoryContract(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.laboratoryContract, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }